import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import PrizeDraw from './PrizeDraw';
import Trophy from './Trophy';
import { useSweep } from '../../hooks/useSweep';

const PrizeDrawCard = ({
    eventName,
    TermsLink,
    hadEntry,
    didEntryWin,
    prize
}) => {
    const inPrizeDraw = hadEntry && didEntryWin;
    const { sweep } = useSweep();

    const { winnerName, winnerLocation } = sweep;
    const hasWinner = !!(winnerName && winnerLocation);

    const winnerAnnouncement = hasWinner ? (
        <>
            🎉 <Styled.Highlighted>Prize Draw winner</Styled.Highlighted> has
            been picked! Congratulations{' '}
            <Styled.Highlighted>{winnerName}</Styled.Highlighted> from{' '}
            {winnerLocation}.
        </>
    ) : (
        <>Come back soon to see the winner.</>
    );

    return (
        <Styled.PrizeDrawCardContainer>
            {inPrizeDraw && <Trophy />}
            <Styled.PrizeDrawCardBox inPrizeDraw={inPrizeDraw}>
                {hadEntry && (
                    <PrizeDraw
                        eventName={eventName}
                        didEntryWin={didEntryWin}
                        prize={prize}
                    />
                )}
                <Styled.Heading>What happens next?</Styled.Heading>
                <Styled.TextWithSmallerMargin>
                    {winnerAnnouncement}
                </Styled.TextWithSmallerMargin>
                <TermsLink>
                    <Styled.TermsLink>
                        18+ and UK only, T&Cs apply, see here.
                    </Styled.TermsLink>
                </TermsLink>
            </Styled.PrizeDrawCardBox>
        </Styled.PrizeDrawCardContainer>
    );
};

PrizeDrawCard.propTypes = {
    eventName: PropTypes.string.isRequired,
    TermsLink: PropTypes.func.isRequired,
    hadEntry: PropTypes.bool.isRequired,
    didEntryWin: PropTypes.bool.isRequired,
    prize: PropTypes.string.isRequired
};

export default PrizeDrawCard;
